import uniqBy from 'lodash/uniqBy';

export default ({ phase, packet }) => {
	const contacts = phase?.contacts;

	const forms =
		packet?.packet_forms?.reduce(
			(acc, form) => ({
				[form.form_id]: {
					formData: JSON.parse(form.form_data),
					formDefinition: JSON.parse(form.form_definition).elements.form_root
				},
				...acc
			}),
			{}
		) ?? {};

	return {
		getPhaseValue(field) {
			return phase?.[field] || null;
		},
		getContactField(id = null, field) {
			const contact = id && contacts.find(x => x.contact_id === id);
			const fieldVal = contact && Object.prototype.hasOwnProperty.call(contact, field) && contact[field];
			return fieldVal || null;
		},
		getDataList(listName) {
			switch (listName) {
				case 'projects': {
					return window.projectList;
				}
				case 'clients': {
					return window.clientList;
				}
				case 'contacts': {
					return (
						uniqBy(
							contacts?.map(contact => ({
								...contact,
								name: `${contact.first_name} ${contact.last_name}`
							})),
							'name'
						) ?? {}
					);
				}
				case 'employees': {
					return window.employeeList;
				}
			}
		},
		getFormData(formId) {
			return forms?.[formId]?.formData ?? {};
		},
		getFormDefinition(formId) {
			return forms?.[formId]?.formDefinition ?? null;
		},
		getSelectOptions(def) {
			const parts = def.name.split(':');

			if (parts[0] === 'employees') {
				return (
					window.employeeList.map(({ name }) => ({
						label: name,
						value: name
					})) ?? []
				);
			} else {
				const isList = parts?.length > 1 ?? false;
				const vals = isList ? this.getDataList(parts[0]) : this.getPhaseValue(parts[0]);

				return (
					vals?.map(val => ({
						label: val[def.text || def.name],
						value: val[def.value || def.name]
					})) ?? []
				);
			}
		}
	};
};
